import DOMPurify from 'isomorphic-dompurify';
import type { FC } from 'react';
import { Box } from '../Box';

export type SeoTextBlockProps = {
  /** SEO-Text as serialized HTML, which will be displayed as-is with just styling applied */
  seoText: string;
};

/**
 * Renders a pre-formatted HTML SEO-Text block, styled according to the tenant theme.
 * */
export const SeoTextBlock: FC<SeoTextBlockProps> = ({ seoText }) => (
  <Box
    role="contentinfo"
    sx={{
      'h1, h2, h3, h4, h5, h6, p, div': {
        lineHeight: 1.5,
        fontSize: '1.1rem',
        '&::after': {
          content: '""',
          display: 'block',
          height: '0.25rem',
          width: '3.5rem',
          backgroundColor: 'primary.main',
          marginTop: 0.6,
        },
      },
      'li, li a': {
        fontSize: '1rem',
        lineHeight: 1.5,
      },
      a: {
        ':only-child': {
          fontSize: '1.1rem',
        },
        ':link, :visited, :hover, :active': {
          color: 'inherit',
          outline: 0,
        },
      },
    }}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(seoText) }}
  />
);
